export default class StralkastarenAdministratorHelper {
  public static getFileNameFromContentDispositionHeader(headers: Headers, fallbackName: string): string {
    const contentDisposition = headers.get('Content-Disposition');
    if (!contentDisposition) return fallbackName;

    const matches = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
    return matches && matches[1] ? matches[1].replace(/['"]/g, '') : fallbackName;
  }
}
